import { makeStyles, tokens } from "@fluentui/react-components";
import { designTokens } from "theme/designTokens";

export const useStyles = makeStyles({
  wrapper: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: designTokens.spacing[4],
    textAlign: "center",
    padding: designTokens.spacing[6],
    boxSizing: "border-box",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  message: {
    fontSize: designTokens.fontSize.base,
    color: tokens.colorNeutralForeground2,
  },
  link: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
  },
});
